export type SlaDurationType = '24_7' | 'SERVICE_HOURS';

export const SlaDurationType = {
  247: '24_7' as SlaDurationType,
  SERVICEHOURS: 'SERVICE_HOURS' as SlaDurationType,
};
